import { render, staticRenderFns } from "./PersonalRequestEditDialog.vue?vue&type=template&id=1c4ace2c"
import script from "./PersonalRequestEditDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalRequestEditDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PersonalRequestEditDialog.vue?vue&type=style&index=0&id=1c4ace2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports